import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Formik } from 'formik'
import * as Yup from 'yup'

import Modal from 'common/components/feedback/Modal'

import { Button, Col, DefaultInput, Row } from 'common/components'

interface AddProviderProps {
  visible: boolean
  afterSuccessAdd?: (providerName: string) => void
  onSubmitModal: (providerName: string) => void
  onCancel: () => void
}

export type AddProvider = {
  providerName: string
}

const AddProviderModal = (props: AddProviderProps) => {
  const { t: translate } = useTranslation(['ee-dashboard', 'translation'])
  const [isFormValid, setIsFormValid] = useState<boolean>(false)

  let submitFormHandler: () => Promise<any> = () => new Promise(() => {})

  const initialValues: any = {
    providerName: '',
  }

  const onSubmit = (values: AddProvider) => {
    props.onSubmitModal(values.providerName)
  }

  const modalFooterActions = [
    <Button key="back" onClick={props.onCancel}>
      {translate('translation:general.cancel')}
    </Button>,
    <Button key="submit" type="primary" disabled={!isFormValid} onClick={() => submitFormHandler()}>
      {translate('translation:general.add')}
    </Button>,
  ]

  return (
    <Modal
      title={translate('get-reimburse.request.add-new-service-provider-title')}
      visible={props.visible}
      destroyOnClose
      closable
      onCancel={props.onCancel}
      footer={modalFooterActions}
    >
      <Formik
        enableReinitialize={true}
        validationSchema={formValidator(translate)}
        initialValues={initialValues}
        onSubmit={onSubmit}
        validate={(values) => {
          setIsFormValid(formValidator(translate).isValidSync(values))
        }}
      >
        {(formik) => {
          const { handleSubmit, submitForm } = formik
          submitFormHandler = submitForm
          return (
            <form onSubmit={handleSubmit} autoComplete="off">
              <Row>
                <Col span={12} className="pr-8">
                  <DefaultInput
                    label={translate('get-reimburse.request.provider-name-label')}
                    labelCustomStyle={'color-gray-8 block pb-8'}
                    name="providerName"
                  />
                </Col>
              </Row>
            </form>
          )
        }}
      </Formik>
    </Modal>
  )
}

const formValidator = (translate: (key: string) => string) =>
  Yup.object({
    providerName: Yup.string()
      .trim()
      .typeError(translate('translation:general.required'))
      .required(translate('translation:general.required')),
  })

export default AddProviderModal
